<template>
  <div id="app" v-if="appShow">
    <router-view />
  </div>
</template>
<script>
import { wxLocate } from "./assets/js/wechat";
export default {
  created() {
    this.getInfo();
  },
  mounted() {
    window.top == window.self && wxLocate(); // 非iframe内，则判断微信网页环境
  },
  data() {
    return {
      appShow: false,
    };
  },
  methods: {
    async getInfo() {
      const id = new URLSearchParams(new URL(window.location.href).search).get(
        "id"
      );
      if (id && id != null) {
        const { data } = await this.$http.get(
          `/resources/getByExhibitionId?exhibitionId=${id}`
        );
        window._pageData =
          data.content && data.content != null ? JSON.parse(data.content) : {};
        this.appShow = true;
      }
    },
  },
};
</script>
<style lang="scss">
body,
html,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
p {
  text-align: justify;
  word-break: break-all;
  margin: 0;
}
.cursor-pointer {
  cursor: pointer;
  user-select: none;
}
</style>
